/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}.portal-announcement-editor-content[_ngcontent-%COMP%]   .editor-inline-content[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center}.portal-announcement-editor-content[_ngcontent-%COMP%]   .editor-inline-content[_ngcontent-%COMP%]   .dx-tagbox[_ngcontent-%COMP%]{width:100%}.portal-announcement-editor-content[_ngcontent-%COMP%]   .editor-inline-content[_ngcontent-%COMP%]   .dx-datebox[_ngcontent-%COMP%]{width:120px;margin-right:.5rem}"];
export { styles as styles };
